"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchAll = void 0;
const AbstractSearchCommand_1 = require("./AbstractSearchCommand");
class SearchAll extends AbstractSearchCommand_1.AbstractSearchCommand {
    constructor() {
        super(...arguments);
        this.execute = async (api, page, pageSize) => {
            const url = '/applications';
            const response = await api.get(url, {
                params: {
                    includeDeviceCount: true,
                    includeActivity: true,
                    page: page,
                    per_page: pageSize,
                },
                validateStatus: (status) => (status >= 200 && status < 300) || status === 404,
            });
            return {
                list: this.ensureIsArray(response.data).map((app) => this.addActivityData(app, response)),
                total: parseInt(response.headers['total']),
            };
        };
    }
}
exports.SearchAll = SearchAll;
//# sourceMappingURL=SearchAll.js.map